module.exports = __webpack_public_path__ + "static/media/password-recovery.d96f61ef.png";